import { render, staticRenderFns } from "./CompanyNewUserSetting.vue?vue&type=template&id=35bb416c"
import script from "./CompanyNewUserSetting.vue?vue&type=script&lang=js"
export * from "./CompanyNewUserSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports